export const HEADER_HEIGHT = '60px';
export const DESKTOP_MENU_WIDTHS = ['0px', '0px', '160px', '160px'];
export const LOGIN_WITH_CODE_INPUT = '#FBFBFB';
export const LOGIN_WITH_CODE_BUTTON_WITH_SPINNER = '#00AAE7';